import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import classnames from 'classnames';
import { initCaseSupportingImgs } from '../../pagesUtils';
import CaseSupportingFileInput, {
    RemoveAllCaseSupportingFilesBtn,
} from '../../../components/CaseSupportingFileInput/CaseSupportingFileInput';
import useCaseSupportingFileInputFunc from '../../../hooks/useCaseSupportingFileInputFunc';

export default function AwaitingGrid({
    handleChangeInputData,
    disabled,
    awaitRemarks,
    classes,
    selectedStatus,
    resetCaseSupportingImgs,
    removeCaseSupportingImgs,
    caseSupportingImgs = initCaseSupportingImgs,
    setCaseSupportingImgs,
    setCaseSupportingImgsSubject,
}) {
    const {
        assignRef,
        handleSelectPasteBoard,
        pasteBoardSelected,
        handleFileInput,
        handlePaste,
        handleRemoveAllImgs,
        handleRemoveImg,
    } = useCaseSupportingFileInputFunc({
        setCaseSupportingImgs: setCaseSupportingImgs,
        resetCaseSupportingImgs: resetCaseSupportingImgs,
        removeCaseSupportingImgs: removeCaseSupportingImgs,
    });

    const handleSubjectInput = (value, index) => {
        setCaseSupportingImgsSubject(value, index);
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <label>
                    <strong>Remarks For Missing Materials:</strong>
                </label>
                :
            </Grid>

            <Grid item xs={12} sm={8}>
                <TextField
                    disabled={disabled}
                    className={classnames(classes.textField, classes.dense)}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    value={awaitRemarks}
                    onChange={handleChangeInputData}
                />
            </Grid>

            <Grid item xs={12}>
                <div>
                    <RemoveAllCaseSupportingFilesBtn handleRemoveAllImgs={handleRemoveAllImgs} />

                    <Grid>
                        {caseSupportingImgs.map((image, index) => {
                            return (
                                <CaseSupportingFileInput
                                    imgIndex={index}
                                    data={image}
                                    ref={assignRef(index)}
                                    handleSelectPasteBoard={handleSelectPasteBoard}
                                    pasteBoardSelected={pasteBoardSelected[`pasteBoard${index}`]}
                                    handleRemoveImg={handleRemoveImg}
                                    handlePaste={handlePaste}
                                    handleFileInput={handleFileInput}
                                    handleSubjectInput={handleSubjectInput}
                                />
                            );
                        })}
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
}
